import controller from './controller';
import template from './template.html';

routes.$inject = ['$stateProvider', '$urlRouterProvider'];

export default function routes($stateProvider, $urlRouterProvider){

	$stateProvider.state('main.panels', {
		url: '/panels?:redirect',
		controllerAs: 'ctrl',
		controller: controller,
		template: template,
        params: {
            redirect: {
                type: "int",
                value: 1,
                dynamic: true,
            }
        }
	});
	
}





/** WEBPACK FOOTER **
 ** ./src/main/panels/routes.js
 **/